import $http from '@/utils/http'

export function doGet(url) {
    return $http.get(url);
}
export function doPost(url, data) {
    return $http.post(url, data);
}

//查字典接口
export function findListDict(data) {
	return $http.post('/sys/SysDictContent/findListByRedis.do',data)
}
// 市级项目

export function selectCityNum(data) {
	return $http.post('/api/phone/selectCityNum',data)
}
// 省级项目

export function getProjectNum(type) {
	return $http.get('/api/phone/getProjectNum?type='+type)
}
//
// 项目列表
export function getProjectList(type,provinceName,cityName,keyword) {
	return $http.get('/api/phone/getProjectList?type='+type+"&provinceName="+provinceName+"&cityName="+cityName+"&keyword="+keyword)
}